import config from 'constants/config'
import { useTourV2SearchEnabled } from 'hooks/useTourV2SearchEnabled'
import { useMemo } from 'react'

import { isFlightsCredit, isStandaloneFlightsEnabled } from 'selectors/flightsSelectors'
import { useAppSelector } from 'hooks/reduxHooks'
import { getAgentHubAffiliationRules, isAgentHubEnabled } from 'agentHub/selectors/agentHubSelectors'

/**
 * Returns the list of enabled search verticals for the current brand
 */
function useGlobalSearchVerticals(): Array<App.SearchVerticalItem> {
  // TODO: this should be single selector @arminmon
  const standaloneFlightsEnabled = useAppSelector((state) => isStandaloneFlightsEnabled(state) || isFlightsCredit(state))
  const agentHubAffiliationRules = useAppSelector((state) => getAgentHubAffiliationRules(state))

  const canBookCruise = !isAgentHubEnabled || agentHubAffiliationRules.canBookCruise
  const canBookCarHire = !isAgentHubEnabled || agentHubAffiliationRules.canBookCarHire

  const toursEnabled = useTourV2SearchEnabled()

  const regionCode = useAppSelector((state) => state.geo.currentRegionCode)
  const isInAvailableCruiseRegion = config.CRUISES_REGIONS.split(',').includes(regionCode)
  const isInAvailableCarHireRegion = config.CARHIRE_REGIONS.split(',').includes(regionCode)

  return useMemo(() => {
    const enabledSearchVerticals = {
      'car-hire': config.CARHIRE_ENABLED && config.CARHIRE_SEARCH_ENABLED && isInAvailableCarHireRegion && canBookCarHire,
      cruises: config.CRUISES_STANDLONE_ENABLED && isInAvailableCruiseRegion && canBookCruise,
      experiences: config.EXPERIENCES_STANDLONE_ENABLED,
      flights: standaloneFlightsEnabled,
      hotels: true,
      tours: toursEnabled,
      'homes-and-villas': config.RENTALS_SEARCH_ENABLED,
      merchandise: config.MARKETPLACE_ENABLED,
    }

    return config.searchVerticalItems.filter((searchVerticalItem) =>
      enabledSearchVerticals[searchVerticalItem.vertical],
    )
  }, [isInAvailableCarHireRegion, isInAvailableCruiseRegion, standaloneFlightsEnabled, toursEnabled, canBookCarHire, canBookCruise])
}

export default useGlobalSearchVerticals
